import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { BadgeType } from 'constants/cover';
import { AdultRoundIcon } from 'icons/AdultRoundIcon';
import { CompleteBadgeIcon } from 'icons/badge/CompleteBadgeIcon';
import { NewBadgeIcon } from 'icons/badge/NewBadgeIcon';
import { PublishedBadgeIcon } from 'icons/badge/PublishedBadgeIcon';
import { UpBadgeIcon } from 'icons/badge/UpBadgeIcon';
import { DirittoRoundIcon } from 'icons/DirittoRoundIcon';
import { HiddenBadgeIcon } from 'icons/badge/HiddenBadgeIcon';
import { ContestBadgeIcon } from 'icons/badge/ContestBadgeIcon';
import { Contest2024Top30Icon } from 'icons/badge/Contest2024Top30Icon';
import { Contest2024Icon } from 'icons/badge/Contest2024Icon';
import { Contest2024Top7Icon } from 'icons/badge/Contest2024Top7Icon';
import { ProposalWantedBadgeIcon } from 'icons/badge/ProposalWantedBadgeIcon';
import { ContestChallengeBadgeIcon } from 'icons/badge/ContestChallengeIcon';
import { AdultBoxIcon } from 'icons/AdultBoxIcon';

interface CoverBadgeProps {
  type: BadgeType;
  className?: string;
}

export const CoverBadge = ({ className, type }: CoverBadgeProps) => (
  <StyledBadge className={className}>
    {
      {
        [BadgeType.DirittoOnly]: <DirittoRoundIcon color={Color.Green400} className="size-[16px]" />,
        [BadgeType.DirittoOriginal]: <DirittoRoundIcon color={Color.Primary500} className="size-[16px]" />,
        [BadgeType.Completed]: <CompleteBadgeIcon />,
        [BadgeType.Up]: <UpBadgeIcon />,
        [BadgeType.Adult]: <AdultRoundIcon className="size-[16px]" fillOpacity={0.6} />,
        [BadgeType.AdultBox]: <AdultBoxIcon className="size-[16px]" color={Color.Gray500} />,
        [BadgeType.New]: <NewBadgeIcon />,
        [BadgeType.Published]: <PublishedBadgeIcon />,
        [BadgeType.Contest]: <ContestBadgeIcon />,
        [BadgeType.ContestChallenge]: <ContestChallengeBadgeIcon />,
        [BadgeType.Hidden]: <HiddenBadgeIcon className="size-[16px]" color={Color.White} />,
        [BadgeType.Contest2024Top30]: <Contest2024Top30Icon />,
        [BadgeType.Contest2024Top7]: <Contest2024Top7Icon />,
        [BadgeType.Contest2024]: <Contest2024Icon />,
        [BadgeType.ProposalWanted]: <ProposalWantedBadgeIcon />,
      }[type]
    }
  </StyledBadge>
);

const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
